import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { PackageTrackerCommonFilterQueryParams, UsePackageTrackerQueryHookParams } from '../types';

const useStuckPackageCountQuery = ({ params, token }: UsePackageTrackerQueryHookParams<PackageTrackerCommonFilterQueryParams>) => {
  const query = useQuery({
    queryKey: ['stuck-packages', { token, params }],
    queryFn: async ({ signal }) => {
      return API.get('/packages/stuck', {
        signal,
        params,
      });
    },
    select: (res) => {
      return res?.data as { stuckPackages: number };
    },
    staleTime: 1000 * 20,
  });

  return query;
};

export default useStuckPackageCountQuery;
